import BotResponseTreeNode from './BotResponseTreeNode';
import SlotConditionalTreeNode from './SlotConditionalTreeNode';
import SlotValueType from './SlotValueType';
import InlineEnumeratedSlotValue from './InlineEnumeratedSlotValue';

class CollectVariableTreeNode {
  intentSlotId: number | null;

  slotName: string | null; // The name of the slot in the intent - intentSlot.slotName

  slotType: string | null; // The name of the slot globally - slot.slotName

  slotValueType: SlotValueType | null;

  slotProvidedStep: BotResponseTreeNode | null;

  fallbackStep: BotResponseTreeNode | null;

  slotConditionals: SlotConditionalTreeNode[];

  inlineEnumeratedValues?: InlineEnumeratedSlotValue[];

  enableInputFields?: boolean;

  maxFileSize?: number;

  allowedFileTypes?: string[];

  collectAsArray?: boolean;

  allowFutureDates?: boolean;

  autofillEnabled?: boolean;

  constructor(
    intentSlotId: number | null,
    slotName: string | null,
    slotType: string | null,
    slotValueType: SlotValueType | null,
    slotProvidedStep: BotResponseTreeNode | null,
    fallbackStep: BotResponseTreeNode | null,
    enableInputFields?: boolean,
    maxFileSize?: number,
    allowedFileTypes?: string[],
    inlineEnumeratedValues?: InlineEnumeratedSlotValue[],
    collectAsArray?: boolean,
    allowFutureDates?: boolean,
    autofillEnabled?: boolean,
    slotConditionals: SlotConditionalTreeNode[] = []
  ) {
    this.intentSlotId = intentSlotId;
    this.slotName = slotName;
    this.slotType = slotType;
    this.slotValueType = slotValueType;
    this.slotProvidedStep = slotProvidedStep;
    this.fallbackStep = fallbackStep;
    this.slotConditionals = slotConditionals || [];
    this.enableInputFields = enableInputFields;
    this.maxFileSize = maxFileSize;
    this.allowedFileTypes = allowedFileTypes;
    this.inlineEnumeratedValues = inlineEnumeratedValues;
    this.collectAsArray = collectAsArray;
    this.allowFutureDates = allowFutureDates;
    this.autofillEnabled = autofillEnabled;
  }
}

export default CollectVariableTreeNode;
